import React, { useState } from 'react'
import { useFormik } from "formik";
import * as Yup from "yup";
import { useParams } from "react-router";
import { createStandaloneToast, InputGroup, Button, Input, InputRightElement, Spinner } from '@chakra-ui/react'
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import Cookies from 'js-cookie';

// import assests and styling
import {Container, Form, Help, InputContainer, SubmitBtn, Wrapper} from "../../styles/login.style";
import {Link} from "react-router-dom";
import { Flex } from '@chakra-ui/react'
import { lock } from '../../assets/auth';
import { decrement, increment } from '../../store/reducers/loading';

const ConfirmPassword = () => {
    const loadingCount = useSelector((state) => state.loading.count);

  const isLoading = () => {
    // console.log(loadingCount);
    return loadingCount > 0;
  }
    const [showPassword, setShowPassword] = useState(false)
    const [showConfirmPassword, setShowConfirmPassword] = useState(false)
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { toast } = createStandaloneToast();
	const { Uid, Token } = useParams();
	const baseUrl = process.env.REACT_APP_BACKEND_URL;

    const formik = useFormik({
      initialValues: {
        password: "",
        password_confirmation: "",
      },
      validationSchema: Yup.object({
        password: Yup.string()
          .min(6, "Must be at least 6 characters")
          .required("Required"),
        password_confirmation: Yup.string()
          .oneOf([Yup.ref("password"), null], "Passwords must match")
          .required("Required"),
      }),
      onSubmit: async (values, { setSubmitting, resetForm }) => {
        dispatch(increment());
            try {
                const resp = await axios.post(
                    `${baseUrl}/api/v1/create_password`,
                    {
                        phone_number: Cookies.get('phone_number'),
                        token: Cookies.get('OTP'),
                        password: values.password,
                        password_confirmation: values.password_confirmation,
                    }
                );
                toast({
                    title: "Password Changed",
                    description: "Your Password has been changed successfully",
                    status: "success",
                    duration: 5000,
                    isClosable: true,
                    position: "top",
                    variant: "left-accent",
                });
                setSubmitting(false);
                resetForm();
                Cookies.remove('phone_number');
                Cookies.remove('OTP');
                dispatch(decrement());
                setTimeout(() => {
                    navigate("/auth/login");
                }, 1000);
            } catch (error) {
                dispatch(decrement());
                setSubmitting(false);
                toast({
                    title: "An error occurred",
                    description: error.response?.data?.message,
                    status: "error",
                    duration: 5000,
                    isClosable: true,
                    position: "top",
                    variant: "left-accent",
                });
                if (error.response && error.response.status === 401) {
                    // Redirect to the login page if the API returns a 401 error
                   navigate("/auth/login");
                  }
            }
            setSubmitting(false);
        },
    });

  return (
    <div>
        <Container>
            <Wrapper>

                <Flex
                    w={'500px'}
                    justifyContent={'start'}
                    alignItems={'start'}
                    flexDir={'column'}
                    margin={'5px auto'}
                    gap={'5px'}
                    textTransform='capitalize'
                >
                    <h2>Create New Password</h2>
                    <p>Please choose a new password</p>
                </Flex>

                <Form onSubmit={formik.handleSubmit}>
                    {formik.touched.last_name && formik.errors.password ? (
                        <div className="red-font">{formik.errors.password}</div>
                    ) : null}
                    <InputContainer>
                        <img src={lock} alt='lock-icon' />
                        
                        <InputGroup p={0} m={0}>
                        <Input 
                            type={showPassword ? 'text' : 'password'} 
                            placeholder="Password"
                            variant={'unstyled'}
                            required
                            _focus={{
                                border: 'none',
                                outline: 'none',
                                background: 'transparent'
                            }}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            name="password" // Add name attribute
                            value={formik.values.password}
                        />
                        <InputRightElement h={'full'}>
                            <Button
                            variant={'ghost'}
                            _focus={{
                                border: 'none',
                                outline: 'none',
                                background: 'transparent'
                            }}
                            onClick={() => setShowPassword((showPassword) => !showPassword)}>
                            {showPassword ? <ViewIcon /> : <ViewOffIcon />}
                            </Button>
                            </InputRightElement>
                        </InputGroup>
                    </InputContainer>

                    {formik.touched.last_name && formik.errors.password_confirmation ? (
                        <div className="red-font">{formik.errors.password_confirmation}</div>
                    ) : null}
                    <InputContainer>
                        <img src={lock} alt='lock-icon' />
                     
                        <InputGroup p={0} m={0}>
                            <Input 
                                type={showConfirmPassword ? 'text' : 'password'} 
                                placeholder="Confirm Password"
                                variant={'unstyled'}
                                _focus={{
                                    border: 'none',
                                    outline: 'none',
                                    background: 'transparent'
                                }}
                                required
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                name="password_confirmation" // Add name attribute
                                value={formik.values.password_confirmation}
                                />
                            <InputRightElement h={'full'}>
                                <Button
                                variant={'ghost'}
                                _focus={{
                                    border: 'none',
                                    outline: 'none',
                                    background: 'transparent'
                                }}
                                onClick={() => setShowConfirmPassword((showPassword) => !showPassword)}>
                                {showConfirmPassword ? <ViewIcon /> : <ViewOffIcon />}
                                </Button>
                            </InputRightElement>
                        </InputGroup>
                    </InputContainer>
                    {isLoading()? 
                    <SubmitBtn><Spinner /></SubmitBtn>
                :
                <SubmitBtn type="submit">Submit</SubmitBtn>
                }
                    

                    <p id="already-user">You have an account? <Link to="/auth/login">Sign in</Link></p>
                </Form>
            </Wrapper>
        </Container>
    </div>
  )
}

export default ConfirmPassword